<template>
  <div>
    <div class="toolbar">
      <el-input v-model="keyword" clearable placeholder="姓名/电话/工种" style="width:220px" @keyup.enter.native="load" />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增工人</el-button>
      <el-button type="primary" icon="el-icon-upload2" @click="openImport">导入</el-button>
    </div>
    <el-table :data="pageList" border v-loading="loading">
      <el-table-column prop="name" label="姓名" width="120" />
      <el-table-column prop="phone" label="电话" width="140" />
      <el-table-column prop="workTypeName" label="工种" min-width="160" show-overflow-tooltip />
      <el-table-column prop="loginUsername" label="登录账号" width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.loginUsername || '-' }}</template>
      </el-table-column>
      <el-table-column prop="enabled" label="状态" width="90">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.enabled===1?'success':'info'">{{ row.enabled===1?'启用':'停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row)">编辑</el-button>
          <el-button type="text" @click="openAccount(row)">开通账号</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog :title="form.id?'编辑工人':'新增工人'" :visible.sync="visible" width="480px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="姓名" required><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="电话" required><el-input v-model="form.phone" /></el-form-item>
        <el-form-item label="工种" required>
          <dict-select-with-add
            v-model="form.workTypeIdList"
            dict-type="WORKER_TYPE"
            value-field="id"
            multiple
            add-text="添加工种"
            label-placeholder="如：木工、水电工"
            placeholder="选择工种（可多选）"
          />
        </el-form-item>
        <el-form-item label="状态"><el-switch v-model="form.enabled" :active-value="1" :inactive-value="0" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="accountHasAccount?'工人账号':'开通工人账号'" :visible.sync="accountVisible" width="460px">
      <p style="margin:0 0 12px;color:#64748b;font-size:13px">工人：{{ accountWorkerName }}（角色：工人）</p>
      <p v-if="accountUsageTip" class="quota-tip">{{ accountUsageTip }}</p>
      <el-form :model="account" label-width="90px">
        <el-form-item label="登录账号" required>
          <el-input v-model="account.username" placeholder="手机号或用户名" />
        </el-form-item>
        <el-form-item label="密码" :required="!accountHasAccount">
          <el-input
            v-model="account.password"
            type="password"
            show-password
            :placeholder="accountHasAccount?'不修改请留空；填写须含字母和数字':'至少6位，含字母和数字'"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="accountVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveAccount">
          {{ accountHasAccount ? '保存' : '开通' }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入工人" :visible.sync="importVisible" width="560px" @close="resetImport">
      <div class="import-steps">
        <p>1. 先下载模板，按表头填写后上传。</p>
        <el-button type="text" icon="el-icon-download" @click="downloadTemplate">下载导入模板</el-button>
        <div class="import-tips">
          <div class="import-tips-title">说明</div>
          <ol>
            <li>请从第2行开始填写，勿修改表头；带红星列为必填。</li>
            <li>工种可多选，多个工种请用顿号、逗号分隔；也可从下拉选择，必填。</li>
            <li>电话必填，且不可与系统已有或文件内重复。</li>
            <li>全部校验通过后才会导入。</li>
          </ol>
        </div>
        <p style="margin-top:12px">2. 上传填写好的 Excel（.xlsx / .xls）。</p>
        <el-upload
          ref="importUpload"
          action=""
          :auto-upload="false"
          :limit="1"
          accept=".xlsx,.xls"
          :on-change="onImportFileChange"
          :on-remove="onImportFileRemove"
          :file-list="importFileList"
        >
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>
      </div>
      <div v-if="importErrors.length" class="import-errors">
        <div class="import-errors-title">
          校验未通过：总计 {{ importTotal }} 条，成功导入 0 条。问题如下：
        </div>
        <el-table :data="importErrors" border size="mini" max-height="280">
          <el-table-column prop="message" label="问题" min-width="220" />
          <el-table-column label="行号" min-width="160">
            <template slot-scope="{ row }">{{ row.rowText || (row.rows || []).join('，') }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="importVisible=false">关闭</el-button>
        <el-button type="primary" :loading="importing" :disabled="!importFile" @click="doImport">开始导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listWorkers, saveWorker, deleteWorker,
  getWorkerAccount, saveWorkerAccount,
  downloadWorkerImportTemplate, importWorkers
} from '../../api/labor'
import { fetchMe } from '../../api/auth'
import ListPagination from '../../components/ListPagination.vue'
import DictSelectWithAdd from '../../components/DictSelectWithAdd.vue'
import listPaging from '../../mixins/listPaging'
import { passwordError } from '../../utils/password'
import { accountUsageText, planNameOf } from '../../utils/plan'

export default {
  name: 'Worker',
  components: { ListPagination, DictSelectWithAdd },
  mixins: [listPaging],
  data() {
    return {
      keyword: '',
      list: [],
      loading: false,
      saving: false,
      visible: false,
      form: {},
      accountVisible: false,
      accountWorkerId: null,
      accountWorkerName: '',
      accountHasAccount: false,
      account: { username: '', password: '' },
      importVisible: false,
      importing: false,
      importFile: null,
      importFileList: [],
      importErrors: [],
      importTotal: 0
    }
  },
  computed: {
    accountUsageTip() {
      const user = this.$store.state.user || {}
      const usage = accountUsageText(user)
      if (!usage) return ''
      const plan = planNameOf(user)
      return plan ? `当前套餐：${plan}（${usage}）` : `当前${usage}`
    }
  },
  created() {
    this.load()
  },
  methods: {
    async refreshQuota() {
      try {
        const res = await fetchMe()
        this.$store.commit('patchUser', res.data || {})
      } catch (e) { /* ignore */ }
    },
    async load() {
      this.loading = true
      try {
        const res = await listWorkers({ keyword: this.keyword })
        this.list = res.data || []
        this.page = 1
      } finally { this.loading = false }
    },
    openEdit(row) {
      this.form = row
        ? {
          id: row.id,
          name: row.name,
          phone: row.phone,
          workTypeIdList: Array.isArray(row.workTypeIdList) && row.workTypeIdList.length
            ? [...row.workTypeIdList]
            : (row.workTypeIds ? row.workTypeIds.split(',').map((x) => Number(x.trim())).filter((x) => x) : []),
          enabled: row.enabled == null ? 1 : row.enabled,
          remark: row.remark
        }
        : { id: null, name: '', phone: '', workTypeIdList: [], enabled: 1, remark: '' }
      this.visible = true
    },
    async save() {
      if (!this.form.name) return this.$message.warning('请填写姓名')
      if (!this.form.phone || !String(this.form.phone).trim()) {
        return this.$message.warning('请填写电话')
      }
      if (!this.form.workTypeIdList || !this.form.workTypeIdList.length) {
        return this.$message.warning('请选择工种')
      }
      this.saving = true
      try {
        await saveWorker(this.form)
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } finally { this.saving = false }
    },
    async openAccount(row) {
      this.accountWorkerId = row.id
      this.accountWorkerName = row.name
      this.account = { username: '', password: '' }
      this.accountHasAccount = false
      this.accountVisible = true
      await this.refreshQuota()
      try {
        const res = await getWorkerAccount(row.id)
        const data = res.data || {}
        this.accountHasAccount = !!data.hasAccount
        this.account = {
          username: data.username || row.phone || '',
          password: ''
        }
      } catch (e) {
        this.account = {
          username: row.loginUsername || row.phone || '',
          password: ''
        }
        this.accountHasAccount = !!row.hasAccount
      }
    },
    async saveAccount() {
      if (!this.account.username) return this.$message.warning('请填写登录账号')
      if (!this.accountHasAccount && !this.account.password) {
        return this.$message.warning('请设置密码')
      }
      const pwdErr = passwordError(this.account.password, !this.accountHasAccount)
      if (pwdErr) return this.$message.warning(pwdErr)
      this.saving = true
      try {
        const payload = { username: this.account.username }
        if (this.account.password) payload.password = this.account.password
        await saveWorkerAccount(this.accountWorkerId, payload)
        this.$message.success(this.accountHasAccount ? '账号已保存' : '账号已开通')
        this.accountVisible = false
        await this.refreshQuota()
        this.load()
      } finally { this.saving = false }
    },
    onDelete(row) {
      this.$confirm(`确认删除工人「${row.name}」？`, '提示', { type: 'warning' })
        .then(async () => { await deleteWorker(row.id); this.$message.success('已删除'); this.load() })
        .catch(() => {})
    },
    openImport() {
      this.resetImport()
      this.importVisible = true
    },
    resetImport() {
      this.importFile = null
      this.importFileList = []
      this.importErrors = []
      this.importTotal = 0
      this.importing = false
    },
    onImportFileChange(file, fileList) {
      this.importFileList = fileList.slice(-1)
      this.importFile = file.raw || null
      this.importErrors = []
      this.importTotal = 0
    },
    onImportFileRemove() {
      this.importFile = null
      this.importFileList = []
      this.importErrors = []
      this.importTotal = 0
    },
    async downloadTemplate() {
      try {
        const res = await downloadWorkerImportTemplate()
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '工人导入模板.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('模板下载失败')
      }
    },
    async doImport() {
      if (!this.importFile) return this.$message.warning('请先选择文件')
      this.importing = true
      this.importErrors = []
      try {
        const res = await importWorkers(this.importFile)
        const data = res.data || {}
        const total = data.total == null ? 0 : Number(data.total)
        const imported = data.imported == null ? 0 : Number(data.imported)
        this.importTotal = total
        if (data.ok) {
          this.$message.success(`导入完成：总计 ${total} 条，成功导入 ${imported} 条`)
          this.importVisible = false
          this.load()
        } else {
          this.importErrors = data.errors || []
          this.$message.error(`校验未通过：总计 ${total} 条，成功导入 0 条`)
        }
      } catch (e) { /* interceptor */ }
      finally {
        this.importing = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.quota-tip {
  margin: 0 0 12px;
  padding: 8px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #475569;
  font-size: 13px;
  line-height: 1.5;
}
.import-steps { line-height: 1.6; }
.import-tips {
  margin-top: 8px;
  padding: 10px 12px;
  background: #f8fafc;
  border-radius: 6px;
  color: #475569;
  font-size: 13px;
}
.import-tips-title { font-weight: 600; margin-bottom: 4px; color: #334155; }
.import-tips ol { margin: 0; padding-left: 18px; }
.import-errors { margin-top: 14px; }
.import-errors-title { margin-bottom: 8px; color: #b91c1c; font-size: 13px; }
</style>
